// 电子保函 -> 保费开票申请
import request from "../../request.js";
let bhNgs = "/baohanNGS";

// 查询保费开票申请列表
export const getSelectInvoiceList = function(data) {
  return request({
    url: bhNgs + "/selectInvoiceList",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};

// 查询保费开票申请信息
export const getSelectInvoiceInfo = function(data) {
  return request({
    url: bhNgs + "/selectInvoiceInfo",
    method: "post",
    requestConfig: {
      hideLoading: true,
    },
    data,
  });
};
